import type { AccessRequest } from '../schemas/projectAccess.ts'

export function accessRequestKey(request: AccessRequest): string {
  return request.provider === 'otp' ? request.id : `${request.provider}:${new URL(request.url).origin}`
}

export function distinctAccessRequests(requests: AccessRequest[]): AccessRequest[] {
  const seen = new Set<string>()
  return requests.filter(request => {
    const key = accessRequestKey(request)
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}
